export const getCustomPromptsData = ({ customPrompts: { data } }) => data;

export const checkCustomPromptsFetching = ({ customPrompts: { fetchingData } }) => fetchingData;
